import JobPortalActivePage from '@/src/jobPortal/common/containers/JobPortalActivePage';
import ClinicEmployeesSearch from '@/src/Search/containers/ClinicEmployeesSearch';
import {SectionContainer} from '@/src/ui';

const AllCandidatesLayout = () => {
  return (
    <JobPortalActivePage>
      <SectionContainer>
        <ClinicEmployeesSearch isAllCandidatesPage={true} />
      </SectionContainer>
    </JobPortalActivePage>
  );
};

export default AllCandidatesLayout;
